import { Suspense, useEffect } from "react";
import { initBrandTracking } from "./constants/Tracking";
import AppRoutes from "./view/components/routes/AppRoutes";
import OldApkForceUpdateModal from "./view/components/OldApkForceUpdateModal/OldApkForceUpdateModal";
import { isApkCopyLinkDomain } from "./constants/apkCopyLink";
import Loader from "./view/components/shared/Loader";
import { getEnvVariable } from "./constants/brandConfig";
import { BRAND_NAME, META_TITLE, META_DESCRIPTION, domain } from "./constants/Branding";
import { store } from "./App.utils";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import AppErrorBoundary from "./view/components/shared/AppErrorBoundary";

function App() {
    const loadTheme = () => {
    const cssFolderName = getEnvVariable(domain, 'FOLDER_NAME') ;
    const cssFilePath = `/theme/${cssFolderName}/variables.css`;

    // Check if an existing theme file is already loaded
    let existingLink = document.getElementById('site-theme');

    if (existingLink) {
      // Replace existing theme
      existingLink.setAttribute('href', cssFilePath);
    } else {
      // Create new theme link
      const link = document.createElement('link');
      link.id = 'site-theme';
      link.rel = 'stylesheet';
      link.href = cssFilePath;
      document.head.appendChild(link);
    }

    console.log(`Loaded theme: ${cssFolderName}`);
  };

  const updateFavicon = () => {
    let link: any = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.setAttribute(
      'href',
      getEnvVariable(domain, 'favicon') || '/theme/Ultrawin/favicon.png'
    );
  };

  const updateTitle = () => {
    document.title = META_TITLE || BRAND_NAME || '';
  };

  const updateMetaDescription = () => {
    if (!META_DESCRIPTION) return;

    let meta: any = document.querySelector("meta[name='description']");

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", META_DESCRIPTION);
  };

    useEffect(() => {
    // TODO: this should only be called once.
    // getDomainConfig();
    // Load theme file
    loadTheme();
    // Load favicon
    updateFavicon();
    // Update title
    updateTitle();
    // Set this brand's meta description, if configured
    updateMetaDescription();
    // Init this brand's Facebook Pixel / GTM / gtag, if configured
    initBrandTracking();
  }, []);
  return (
    <div className="h-full">
      <Provider store={store}>
        <Suspense fallback={<Loader />}>
          <AppErrorBoundary>
            {isApkCopyLinkDomain() ? (
                <OldApkForceUpdateModal />
              ) : (
                <AppRoutes />
              )}
          </AppErrorBoundary>
        </Suspense>
        <ToastContainer />
      </Provider>
    </div>
  );
}

export default App;
